import gql from 'graphql-tag';

export const CREATE_CASE_STUDY = gql`
  mutation CreateCaseStudy($input: CaseStudyCreate!) {
    createCaseStudy(input: $input) {
      id
    }
  }
`;

export const UPDATE_CASE_STUDY = gql`
  mutation UpdateCaseStudy($id: ID!, $input: CaseStudyUpdate) {
    updateCaseStudy(id: $id, input: $input) {
      id
    }
  }
`;

export const DELETE_CASE_STUDY = gql`
  mutation DeleteCaseStudy($id: ID!) {
    deleteCaseStudy(id: $id) {
      id
    }
  }
`;
